export const SIDEBAR_ALLOWED_OVERLAY_CLS = `sidebar-allowed-overlay`;
export const ECHARTS_CONTAINER_CLS = 'echarts-for-react';
export const ABOVE_ALL_CLS = `above-all`;
export const FS_MASK_CLS = 'fs-mask';
export const EXECUTION_TOAST_ATTR = {
  name: 'data-component-name',
  value: 'job_status_toast'
};
export const DIALOG_OVERLAY_COMPONENT_NAME_ATTR = {
  name: 'data-component-name',
  value: 'dialog_overlay'
};
export const COPILOT_BUTTON_LABEL_ATTR = {
  name: 'aria-label',
  value: 'copilot'
};
export const FX_BUTTON_LABEL_ATTR = {
  name: 'aria-label',
  value: 'fx'
};
export const COPILOT_BUTTON_ATTR = {
  [COPILOT_BUTTON_LABEL_ATTR.name]: COPILOT_BUTTON_LABEL_ATTR.value
};
export const FX_BUTTON_ATTR = {
  [FX_BUTTON_LABEL_ATTR.name]: FX_BUTTON_LABEL_ATTR.value
};
export const DIALOG_OVERLAY_ATTR = {
  [DIALOG_OVERLAY_COMPONENT_NAME_ATTR.name]: DIALOG_OVERLAY_COMPONENT_NAME_ATTR.value
};
export const DATA_DRAWER_BUTTON_LABEL_ATTR = {
  name: 'aria-label',
  value: 'data table toggle'
};
export const DATA_DRAWER_BUTTON_ATTR = {
  [DATA_DRAWER_BUTTON_LABEL_ATTR.name]: DATA_DRAWER_BUTTON_LABEL_ATTR.value
};
export const RUN_BUTTON_ATTR_NAME = 'data-run-type';
export enum RUN_BUTTON_ATTR_VALUE {
  Pipeline = 'Pipeline',
  GemDialog = 'GemDialog'
}
export const DEPLOYMENT_DOCS_URL = 'https://docs.prophecy.io/self-hosted-helm-installation';
export const CONTACT_SUPPORT_URL = 'https://www.prophecy.io/contact-us';
export const ZENDESK_URL = 'https://prophecy.zendesk.com/hc/en-us';

export const SUB_GRAPH_NODE_TYPES = {
  subGraphInNode: 'subGraphInNode',
  subGraphOutNode: 'subGraphOutNode'
};
export const PATH_ROOTS = {
  COMPONENT: 'component',
  RECORD: 'record',
  WORKFLOW: '$.workflow',
  JOB: '$.job',
  SQL: '$.sql',
  EXPECTATION: '$.expectation',
  LINEAGE: '$.lineageGraph',
  METADATA: '$.metadata',
  REUSABLE_SUBGRAPHS: '$.subgraphSpec',
  COPILOT_AGENT_CURRENT_SESSSION_MESSAGES: '$.chat.messages',
  COPILOT_AGENT_CHAT_SESSIONS: '$.chat.sessions'
};
export const SQL_PATH_ROOTS = {
  currentEntityGraph: `${PATH_ROOTS.SQL}.currentEntityGraph`,
  currentPipelineGraph: `${PATH_ROOTS.SQL}.currentPipelineGraph`
};
export enum SubgraphType {
  ForEachLoop = 'ForEachLoop',
  TaskGroup = 'TaskGroup'
}
export const PIPELINE_DOCUMENTS_FOLDER_NAME = 'documents';
export const PIPELINE_DOCUMENT_TEMPLATE_FOLDER_NAME = 'templates';
export const ATTACHMENT_FOLDER_NAME = 'attachment';

export const defaultUnixCronValue = '0 0/1 * * *';
export const defaultQuartzCronValue = '0 0 0 1/1 * ? *';

export const GRAPH_DEFAULT_ZOOM_FACTOR = 1 / 1.2;

export const DATA_DIFF_STEP_KEY = 'data-diff';

export const DISABLED_PROPHECY_AUTOMATE_MESSAGE = 'Contact Prophecy admin to enable Prophecy Automate';

export const HEADER_VISUAL_CODE_TOGGLE_ID = 'header-visual-code-toggle';

export const SQL_HEADER_JOB_FABRIC_PORTAL_ID = 'sql-header-job-fabric-portal';

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404
};

export const ROW_ID_KEY = '_row_id';

export const LoadDataSampleReqTypes = {
  selectiveRecordsCount: 'SelectiveRecordsCount',
  dataProfiling: 'DataProfiling'
};

export const DISABLED_PROPHECY_AUTOMATE_MESSAGE_PYTHON_BACKEND =
  'Schedules are not supported on Python backend for now';

/** Shown when job runs or scheduling are disabled for Snowflake projects that contain pipelines. */
export const JOBS_NOT_SUPPORTED_SNOWFLAKE_PIPELINE_MESSAGE =
  'Job runs and scheduling are not supported for Snowflake projects that contain pipelines.';

/** Shown when adding pipelines to a job is disabled for Snowflake provider. */
export const PIPELINES_NOT_SUPPORTED_IN_SNOWFLAKE_JOBS_MESSAGE = 'Snowflake Pipelines are not supported in Jobs.';
export const QUERY_PARAM_RUN_ID = 'runId';
export const QUERY_PARAM_RUN_TYPE = 'runType';

export const ATTACHMENT_PATH_REGEX = /^.*\/attachment\//;
